import {Component} from '@angular/core';
import {FormInlineiframeComponent} from "../form-inlineiframe/form-inlineiframe.component";

@Component({
  selector: 'tig-form-blacklist',
  templateUrl: '../form-inlineiframe/form-inlineiframe.component.html',
  styleUrls: ['../form-inlineiframe/form-inlineiframe.component.scss']
})
export class FormBlacklistComponent extends FormInlineiframeComponent
{

	public static IFRAME_ID = 'iframe-blacklist'

	/**
	 * Function > getIFrameID
	 */
	public getIFrameID()
	{
		return FormBlacklistComponent.IFRAME_ID;
	} // end function getIFrameID

}
